import { periodTypes } from "../../const";

const DEBUG_LOCAL = true

const dataFormater = (date) => {
    if (date instanceof Date) {
        const format = (date) => date < 10 ? `0${date}` : date.toString();
        const year = date.getFullYear();
        const month = format(date.getMonth() + 1);
        const day = format(date.getDate());
        
        const hour = format(date.getHours());
        const minute = format(date.getMinutes());
        const second = format(date.getSeconds());
        
        //YYYY-MM-DD HH:MI:SS
        return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    } else {
        return null
    }
}

/** рассчитывает критерии запроса исходя из выбранных геобъектов и периода*/
export const getCriteria = (
    dateRangeCriteria,
    rangeStartDate,
    rangeEndDate
) => {

    let criteria = {};

    if (dateRangeCriteria === periodTypes.TODAY) {
        const now = new Date()
        criteria = {
            byNow: now.valueOf(),
            byNowStr: dataFormater(now)
        }
    } else if (dateRangeCriteria === periodTypes.WEEK || dateRangeCriteria === periodTypes.PERIOD) {
        criteria = {
            byDate: {
                start: rangeStartDate?.valueOf(),
                end: rangeEndDate?.valueOf(),
                startStr: dataFormater(rangeStartDate),
                endStr: dataFormater(rangeEndDate),
            }
        }
    }
    DEBUG_LOCAL && console.log('!!!criteria:', criteria);
    return criteria
}
